var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"billing-by-tabs"},[_c('VuetifyToolBar',{attrs:{"hide-back-button":true,"title":"Facturación"}}),_c('v-container',[_c('VuetifyTabs',{attrs:{"items":_vm.currentTabs}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }